module.exports = __webpack_public_path__ + "img/blog-4.008df58f.jpg";